import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import { IFiles } from "../types/Task-interface";

export const fetchTaskCase = createAsyncThunk(
    'contract/fetchTaskCase',
    async ({ TaskID }: {
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTaskCase', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { task: data.Task, TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchFileDownload = createAsyncThunk(
    'contract/fetchFileDownload',
    async ({ TaskID, FileID }: {
        TaskID: string,
        FileID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "FileID": FileID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'downloadFile', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchTaskFiles = createAsyncThunk(
    'contract/fetchTaskFiles',
    async ({ TaskID }: {
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTaskFiles', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { files: data.Files, TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchTaskStatusHistory = createAsyncThunk(
    'contract/fetchTaskStatusHistory',
    async ({ TaskID }: {
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTaskStatusHistory', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { statusHistory: data.StatusHistory, TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchTaskMessages = createAsyncThunk(
    'contract/fetchTaskMessages',
    async ({ TaskID }: {
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTaskMessages', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { messages: data.Messages, TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSendMessage = createAsyncThunk(
    'contract/fetchSendMessage',
    async ({ TaskID, Files, Text, ToRework }: {
        TaskID: string;
        Text: string;
        ToRework: boolean;
        Files: IFiles;
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "Text": Text,
                "Files": Files,
                "ToRework": ToRework
            };

            const response = await getRequest(requestBody, 'dms-hr', 'createTaskMessage', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { id: data.TaskMessage.ID, number: data.TaskMessage.Number };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchSetTaskMessagesRead = createAsyncThunk(
    'contract/fetchSetTaskMessagesRead',
    async ({ TaskID, MessageIDs }: {
        TaskID: string;
        MessageIDs: string[]
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "MessageIDs": MessageIDs
            };

            const response = await getRequest(requestBody, 'dms-hr', 'setTaskMessagesRead', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { messages: data.Messages, TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetcEditTask = createAsyncThunk(
    'contract/fetcEditTask',
    async ({ TaskID }: {
        TaskID: string;
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "ToApprove": true
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getEditTask', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { taskID: data.Task.ID, taskNumber: data.Task.Number };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);
